






































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';
import PagesBtn from '@/views/auth/components/Btn.vue';
import AppService from '@/services/app';
import AuthService from '@/services/auth';

@Component({
  components: {
    BaseMaterialCard,
    PagesBtn,
  },
})
export default class PagesLogin extends Vue {
  user = {
    username: '',
    password: '',
  };

  config = {
    valid: false,
    clicked: false,
    loader: '',
    showPassword: false,
    rules: {
        required: (value: string) => !!value || '',
    },
  };

  async login() {
    this.config.clicked = true;
    this.config.loader = 'clicked';

    try {

      const response = await AuthService.login(this.user);

      if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
      } else {
          this.$router.push('/');
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.config.clicked = false;
      this.config.loader = '';
    }
  }
}
